import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as AbsiSectionActions from 'src/app/components/absi/store/absi-sections/absi-section.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class AbsiSectionStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }

  initStore() { }

  initListeners() {
    // ABSI Sections
    this.signalRService.hubConnection?.on(Channels.ABSISECTION, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new AbsiSectionActions.AbsiSectionCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new AbsiSectionActions.AbsiSectionUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new AbsiSectionActions.AbsiSectionDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new AbsiSectionActions.AbsiSectionRefresh(data.obj));
      }
    });
  }
}
